import { render, staticRenderFns } from "./ShipperPriceNewPopup.vue?vue&type=template&id=e785eb02&"
import script from "./ShipperPriceNewPopup.vue?vue&type=script&lang=js&"
export * from "./ShipperPriceNewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports